export default "__VITE_ASSET__DnJjIaUH__"